module.exports = __webpack_public_path__ + "85e590783b2abdccbdb26b573a6506e9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/epidemic.png
 ** module id = 1058
 ** module chunks = 0
 **/